import SwitchSelector from 'react-switch-selector'
import '../../styles/Input/InputSwitch.css'
import { useEffect, useState } from 'react'

function InputSwitch({ type, data, setValue, onChange }) {

    const [colors, setColors] = useState('')

    useEffect(() => {

        getColors()

        // eslint-disable-next-line
    }, [])

    function getColors() {

        var colorsFormat = null
        if (type === 'light') {
            colorsFormat = {
                inputSwitch: getComputedStyle(document.documentElement).getPropertyValue('--inputSwitchLight'),
                inputSwitchActive: getComputedStyle(document.documentElement).getPropertyValue('--inputSwitchLightActive'),
                inputSwitchText: getComputedStyle(document.documentElement).getPropertyValue('--inputSwitchLightText'),
            }
        } else {
            colorsFormat = {
                inputSwitch: getComputedStyle(document.documentElement).getPropertyValue('--inputSwitchDark'),
                inputSwitchActive: getComputedStyle(document.documentElement).getPropertyValue('--inputSwitchDarkActive'),
                inputSwitchText: getComputedStyle(document.documentElement).getPropertyValue('--inputSwitchDarkText'),
            }
        }
        setColors(colorsFormat)

    }

    return (

        <div className='switchSelectorContainer'>
            <div className='switchSelector'>
                <SwitchSelector
                    onChange={(value) => { setValue(value); onChange(value) }}
                    options={data}
                    backgroundColor={colors.inputSwitch}
                    selectedBackgroundColor={colors.inputSwitchActive}
                    fontColor={colors.inputSwitchText}
                    fontSize={14}
                />
            </div>
        </div>

    )

}

export default InputSwitch
